import Image, { ImageProps } from 'next/image'

export function Logo({
  hasName,
  isOnDark,
  ...props
}: { hasName?: boolean; isOnDark?: boolean } & Omit<
  ImageProps,
  'src' | 'alt'
>) {
  if (hasName) {
    if (isOnDark) {
      return (
        <Image
          className="w-[130px] h-auto"
          src="/assets/logos/Marit-name-white.png"
          alt=""
          width={260}
          height={30}
          {...props}
        />
      )
    }
    return (
      <>
        <Image
          className="hidden dark:block w-[130px] h-auto"
          src="/assets/logos/Marit-name-white.png"
          alt=""
          width={260}
          height={30}
          {...props}
        />
        <Image
          className="dark:hidden w-[130px] h-auto"
          src="/assets/logos/Marit-name-black.png"
          alt=""
          width={260}
          height={30}
          {...props}
        />
      </>
    )
  }
  return (
    <>
      <Image
        className="w-[39px] h-auto"
        src="/assets/logos/Marit-name.png"
        alt=""
        width={50}
        height={50}
        quality={80}
        {...props}
      />
    </>
  )
}
